/**
 * Valid include relations for User endpoints.
 * These relations can be requested via ?include=status,balances query parameter.
 */
export const VALID_USER_RELATIONS = ['status', 'balances'];
/**
 * Type guard to check if a string is a valid UserIncludeRelation
 */
export function isValidUserRelation(value) {
    return VALID_USER_RELATIONS.includes(value);
}
//# sourceMappingURL=user-include-relation.type.js.map